import "./loader-spinner.css";

export class LoaderSpinner {
    private readonly _elementId = "divLoader";
    private readonly _element: HTMLDivElement;

    constructor(parent?: HTMLElement | null) {
        this._element = this._createElement();

        const overlayHost = LoaderSpinner.getOverlayHost();
        const host = overlayHost instanceof HTMLDialogElement
            ? overlayHost
            : parent ?? document.documentElement;

        host.appendChild(this._element);
    }

    private static getOverlayHost(): HTMLElement {
        const openDialogs = Array.from(
            document.querySelectorAll<HTMLDialogElement>("dialog[open]")
        );

        return openDialogs.length
            ? openDialogs[openDialogs.length - 1]
            : document.documentElement;
    }

    private readonly _createElement = (): HTMLDivElement => {
        const wrapper = document.createElement("div");
        wrapper.id = this._elementId;
        wrapper.classList.add("loader-overlay-wrapper");

        wrapper.setAttribute("aria-hidden", "true");
        wrapper.setAttribute("role", "presentation");

        const loader = document.createElement("div");
        loader.classList.add("loader");
        wrapper.appendChild(loader);

        return wrapper;
    };

    public get element(): HTMLDivElement {
        return this._element;
    }

    public destroy(timeout: number = 250): void {
        setTimeout(() => {
            this._element.remove();
        }, timeout);
    }
}
